import { useQuery, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { getIdentiMarketData } from 'services/apiComparable';

const useRelativeMarketList = (orderId,id) => {

  const{isPending,isSuccess,isError,error,data:fetchedData,refetch} = useQuery({
    queryKey:["existingIdenMarketData",orderId,id],
    queryFn:()=> getIdentiMarketData(orderId,id),
    // keepPreviousData:true,
    // staleTime: 2 * 60 * 60 * 1000,
    enabled: !!orderId && !!id,
  })

  return{isPending, isSuccess, isError,error,fetchedData,refetch}
}

export default useRelativeMarketList